import { CallToAction2 } from '@/components/variants/components/CallToAction2'
import { WhySection4 } from '@/components/variants/components/WhySection4'

import { emitter } from '@/utils/emitter'
import { useEffect, useState } from 'react'
import { HeroHomeVariant5 } from '@/components/variants/components/HeroHomeVariant5'
import { OurCoachesSection } from '@/components/sections/OurCoachesSection'
import { FAQSectionVariant } from '@/components/variants/components/FAQSectionVariant'
import { TestimonialsVariantSection } from '@/components/variants/components/TestimonialsVariantSection'
import { TestimonialsVariantSection2 } from '@/components/variants/components/TestimonialsVariantSection2'
import { HowItWorksSection3 } from '@/components/variants/components/HowItWorksSection3'
import { BonusesSection } from '@/components/sections/BonusesSection'
import { ServiceRiskFreeComponent3 } from '@/components/variants/components/ServiceRiskFreeSection3'
import dynamic from 'next/dynamic'
import { PricingEliteSection } from '@/components/sections/PricingEliteSection'

type Props = {
  prices: any,
}

const DynamicHardScienceOffcanvas = dynamic( // @ts-ignore
  () => import('@/components/offcanvas/HardScienceOffcanvas').then((mod) => mod.HardScienceOffcanvas),
  { ssr: false }
)

export const IndexPageVariant3: React.FC<Props> = ({ prices }) => {
  const [show, setShow] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const closeHandler = () => {
    setShow(false)

    emitter.emit('hard-science-offcanvas-closed')
  }

  const showHandler = (e: any) => {
    if (e && e.stopPropagation) {
      e.stopPropagation()
    }

    setLoaded(true)
    setShow(true)

    emitter.emit('hard-science-offcanvas-opened')
  }

  useEffect(() => {
    if (location.hash === '#hard-science-open') {
      showHandler({})
    }
    emitter.on('hard-science-offcanvas-open', showHandler)

    return () => {
      emitter.off('hard-science-offcanvas-open', showHandler)
    }
  }, [])

  return (
    <>
      <HeroHomeVariant5/>
      <div className="bg--primary">
        <WhySection4 />
        <TestimonialsVariantSection/>
        <HowItWorksSection3/>
        <OurCoachesSection/>
        <TestimonialsVariantSection2/>
        <PricingEliteSection prices={prices}/>
        <BonusesSection></BonusesSection>
        <ServiceRiskFreeComponent3></ServiceRiskFreeComponent3>
        <FAQSectionVariant></FAQSectionVariant>
        <DynamicHardScienceOffcanvas show={show} close={closeHandler} />
        <CallToAction2 title="Join now and achieve <br/> your goals faster" />
      </div>
    </>
  )
}
